const ACRONYM_MAP: Record<string, string> = {
  ultrasound: 'ECHO',
  stress_echo: 'SE',
};

export function studyTypeAcronym(studyType: string): string {
  if (!studyType) return '';
  const mapped = ACRONYM_MAP[studyType.toLowerCase()];
  if (mapped) return mapped;

  // Already short (e.g. "CT", "MRI") — return uppercased
  if (studyType.length <= 5) return studyType.toUpperCase();

  // Fallback: first letter of each word
  return studyType
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}
